import React from 'react';
import { Box, Label } from '@acast/decibel';
import resourceProp from 'shared/helpers/resource-prop';
import Episode from 'resources/episode';
import ConditionsList from './conditions-list';

const AcastPlus = ({ episode }) => {
  return (
    <Box mb={6} flexDirection="column">
      <Label as="span">Acast+</Label>
      <ConditionsList episode={episode} />
    </Box>
  );
};

AcastPlus.propTypes = {
  episode: resourceProp(Episode),
};

export default AcastPlus;
